var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg015Checked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 17C21 19.2091 19.2091 21 17 21H7C4.79086 21 3 19.2091 3 17V7C3 4.79086 4.79086 3 7 3H12C12.5523 3 13 3.44772 13 4C13 4.55228 12.5523 5 12 5H7C5.89543 5 5 5.89543 5 7V17C5 18.1046 5.89543 19 7 19H17C18.1046 19 19 18.1046 19 17V12.15C19 11.5977 19.4477 11.15 20 11.15C20.5523 11.15 21 11.5977 21 12.15V17ZM12 12.59L20.29 4.29C20.6821 3.89788 21.3179 3.89788 21.71 4.29C22.1021 4.68212 22.1021 5.31788 21.71 5.71L12.71 14.71C12.5222 14.8993 12.2666 15.0058 12 15.0058C11.7334 15.0058 11.4778 14.8993 11.29 14.71L7.29 10.71C7.03634 10.4563 6.93728 10.0866 7.03012 9.74012C7.12297 9.39362 7.39362 9.12297 7.74012 9.03012C8.08663 8.93728 8.45634 9.03634 8.71 9.29L12 12.59Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg015Checked);
export default __webpack_public_path__ + "static/media/015-checked.14a2e53f0b59b57ed5df7377b1541c5e.svg";
export { ForwardRef as ReactComponent };